import React from 'react';
import classNames from 'classnames';
import Container from "@scentregroup/ui/components/container";
import Paragraph from "@scentregroup/ui/components/paragraph";
import Logo from "@scentregroup/ui/components/logo";
import { RESPONSIBLE_BUSINESS, RESPONSIBLE_BUSINESS_REPORT, SCENTRE_GROUP_HOME } from '../paths';
import { FooterSection } from './footer-section';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SiteFooter = _ref => {
  let {
    className = null,
    colour = 'seasonal',
    children,
    links = [],
    showAngle = true,
    country
  } = _ref;
  return /*#__PURE__*/_jsx("footer", {
    className: classNames(style.siteFooter, className, {
      [style.showAngle]: showAngle,
      [style.seasonal]: showAngle && colour === 'seasonal',
      [style.brand]: showAngle && colour === 'brand'
    }),
    role: "contentinfo",
    "data-id": "site-footer_index_SiteFooter_footer",
    children: /*#__PURE__*/_jsxs(Container, {
      className: style.container,
      type: "large",
      "data-id": "site-footer_index_SiteFooter_footer_Container",
      children: [/*#__PURE__*/_jsx(Logo, {
        type: "alt",
        className: style.logo,
        "data-id": "site-footer_index_SiteFooter_Container_Logo"
      }), children && /*#__PURE__*/_jsx(FooterSection, {
        "data-id": "site-footer_index_SiteFooter_FooterSection",
        children: children
      }), /*#__PURE__*/_jsxs(FooterSection, {
        className: style.linksSection,
        "data-id": "site-footer_index_SiteFooter_Container_FooterSection_4",
        children: [country && /*#__PURE__*/_jsxs(_Fragment, {
          children: [country === 'Australia' && /*#__PURE__*/_jsx(Paragraph, {
            className: style.responsibleBusinessSection,
            "data-id": "site-footer_index_SiteFooter_Paragraph",
            children: "We acknowledge the Traditional Owners and communities of the lands on which our business operates. We pay our respect to Aboriginal and Torres Strait Islander cultures and to their Elders past and present."
          }), country === 'New Zealand' && /*#__PURE__*/_jsx(Paragraph, {
            className: style.responsibleBusinessSection,
            "data-id": "site-footer_index_SiteFooter_Paragraph_6",
            children: "We recognise the unique role of M\u0101ori as Tangata Whenua of Aotearoa/New Zealand."
          })]
        }), /*#__PURE__*/_jsxs(Paragraph, {
          className: style.responsibleBusinessSection,
          "data-id": "site-footer_index_SiteFooter_FooterSection_Paragraph_7",
          children: ["Scentre Group operates its Westfield Living Centre portfolio with a", ' ', /*#__PURE__*/_jsx("a", {
            href: RESPONSIBLE_BUSINESS,
            "data-id": "site-footer_index_SiteFooter_Paragraph_a",
            children: "responsible business"
          }), " mindest across the four pillars of community, people, environment and economic performance. More information can be found in our", ' ', /*#__PURE__*/_jsx("a", {
            className: style.highlight,
            href: RESPONSIBLE_BUSINESS_REPORT,
            "data-id": "site-footer_index_SiteFooter_Paragraph_a_9",
            children: "2022 Responsible Business Report"
          }), "."]
        }), /*#__PURE__*/_jsxs("div", {
          className: style.linksWrapper,
          "data-id": "site-footer_index_SiteFooter_FooterSection_div",
          children: [links && /*#__PURE__*/_jsx("ul", {
            className: style.linksList,
            "data-id": "site-footer_index_SiteFooter_ul",
            children: links.map(_ref2 => {
              let {
                label,
                href
              } = _ref2;
              return /*#__PURE__*/_jsx("li", {
                "data-id": "site-footer_index_SiteFooter_li",
                children: /*#__PURE__*/_jsx("a", {
                  href: href,
                  className: style.link,
                  "data-id": "site-footer_index_SiteFooter_li_a",
                  children: label
                })
              }, href);
            })
          }), /*#__PURE__*/_jsxs("span", {
            className: style.rightsText,
            "data-id": "site-footer_index_SiteFooter_div_span",
            children: ["\xA9 All rights reserved", ' ', /*#__PURE__*/_jsx("a", {
              href: SCENTRE_GROUP_HOME,
              className: style.highlight,
              "data-id": "site-footer_index_SiteFooter_span_a",
              children: "Scentre Group"
            }), ' ', new Date().getFullYear()]
          })]
        })]
      })]
    })
  });
};